// @flow
import React from "react";

import Selector from '../index';
import type { Props } from '../index'
import { useElements } from 'redux/hooks'


export default ({ value, onChange, ...props }: Props) => {

    const data = useElements();

    return (
        <Selector
            {...props}
            label="Sélection des éléments"
            value={value}
            onChange={onChange}
            data={data}
        />
    )
};